import type { ReactElement, ReactNode } from 'react';
import { RenderCellProps, RenderEditCellProps, SelectEditor } from 'components/DataGrid';
import { createColumn } from './createColumn';
import type { GridRow, GridSummaryRow } from '../types';
import { wrapContainer } from './style.css';
import { CheckboxOption } from 'components/Select';
import { WEBDevice } from 'modules/core/types';
import { webDeviceOptions } from 'options';

function renderValue(props: RenderCellProps<GridRow, GridSummaryRow>): ReactNode {
  const value = props.row.web_device;
  if (!value || value.length === 0) {
    return null;
  }
  const text = value.join(', ');
  return (
    <span className={wrapContainer} title={text}>
      {text}
    </span>
  );
}

function Edit(props: RenderEditCellProps<GridRow, any>): ReactElement {
  const options = props.row.config.web_device?.default as WEBDevice[] | undefined;
  const availableOptions = options ? webDeviceOptions.filter((o) => options.includes(o.value)) : webDeviceOptions;

  return (
    <SelectEditor
      options={availableOptions}
      {...props}
      isSimple
      isSearchable
      isMulti
      Option={CheckboxOption}
      keepOpenOnSelect
      placeholder={options ? 'Product devices' : 'Devices'}
    />
  );
}

export const WebDeviceColumn = createColumn(
  {
    key: 'web_device',
    name: 'Device',
    width: 86,
  },
  {
    renderView: (props) => (props.row.kind === 'MEDIA' ? renderValue(props) : null),
    renderEdit: (props) => <Edit {...props} />,
    displayCellContent: true,
  },
);
